import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-field-error',
  templateUrl: './form-field-error.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class FormFieldErrorComponent {
  @Input({ required: true }) formFieldControl: FormControl | AbstractControl;
}
